import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { StyledTryItYourselfEditorComponent } from "./try-it-yourself-editor-component.scss";
import ButtonComponent from "/components/core/new-button/button-component";
const HOW_TO_AUTHENTICATE = `${process.env.DEVELOPERS_PATH}/api-reference/docs/authentication`;
const GraphiqlComponent = dynamic(()=>import("../graphiql/graphiql-component"), {
    ssr: false
});
const TryItYourselfEditorComponent = ()=>{
    const [hasValidToken, setHasValidToken] = useState(false);
    const [tokenInput, setTokenInput] = useState("");
    const [token, setToken] = useState("");
    useEffect(()=>{
        // Set light theme by default
        // https://github.com/graphql/graphiql/issues/129#issuecomment-1436589207
        window.localStorage.setItem("graphiql:theme", "light");
    }, []);
    const sendToken = ()=>{
        setToken(tokenInput);
    };
    const onAuthorized = useCallback(()=>{
        setHasValidToken(true);
    }, []);
    const toggleTokenPopup = useCallback(()=>{
        setHasValidToken(false);
        setToken("");
    }, []);
    const handleTokenInputChange = (e)=>{
        setTokenInput(e.target.value);
    };
    const renderAuthorizationOverlay = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "authorization-overlay",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "authorization-container",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "enter-token-title",
                        children: "Start with your API V2 token here"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "enter-token-message",
                        children: "Here you can try building your api code live with your real account data."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "token-input-wrapper",
                        children: /*#__PURE__*/ _jsx("input", {
                            placeholder: "thisismytokenandiwillalwayskeepitsafe",
                            value: tokenInput,
                            onChange: handleTokenInputChange
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("a", {
                            className: "where-is-the-token",
                            href: HOW_TO_AUTHENTICATE,
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Where can I find my API token?"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "set-token-btn-container",
                        children: /*#__PURE__*/ _jsx(ButtonComponent, {
                            className: "set-token-btn",
                            size: "lg",
                            onClick: sendToken,
                            disabled: !tokenInput,
                            children: "Start with this API token"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ _jsxs(StyledTryItYourselfEditorComponent, {
        className: "try-it-yourself-editor",
        children: [
            /*#__PURE__*/ _jsx(GraphiqlComponent, {
                token: token,
                onAuthorized: onAuthorized,
                changeToken: toggleTokenPopup
            }),
            !hasValidToken && renderAuthorizationOverlay()
        ]
    });
};
export default TryItYourselfEditorComponent;
